import { ChangeDetectorRef, Component, Input, OnChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { DateHelper } from 'src/app/helpers/dateHelper';
import { StatusSubskrypcji } from 'src/app/models/status-subskrypcji.enum';
import { DestroyComponent } from '../destroy/destroy.component';

@Component({
  selector: 'app-monitorowanie-podmiotu-form',
  templateUrl: './monitorowanie-podmiotu-form.component.html',
  styleUrls: ['./monitorowanie-podmiotu-form.component.scss']
})
export class MonitorowaniePodmiotuFormComponent extends DestroyComponent implements OnChanges {
  @Input() monitorowanieForm: FormGroup;
  @Input() status: string = null;
  today: Date = new Date();
  minDate: Date = new Date();
  minDateTo: Date = new Date();
  maxDate: Date = new Date();
  maxDateTo: Date = new Date();
  statusSubskrypcji = StatusSubskrypcji;
  disableDataOd: boolean = false;
  disableDataDo: boolean = false;
  przedlozORok: boolean = false;

  constructor(private cdr: ChangeDetectorRef) {
    super();
  }


  ngOnChanges(): void {
    if(this.status && (this.status == StatusSubskrypcji.AKTYWNA)) {
      this.maxDateTo = DateHelper.addToDate(this.today.toISOString(), 1, 0, -1);
      this.minDate = DateHelper.addToDate(this.today.toISOString(), 0, 0, 0);
      this.minDateTo = DateHelper.addToDate(this.today.toISOString(), 0, 0, 0);
      this.disableDataOd = true;
      this.disableDataDo = false;
      this.przedlozORok = false;
    }

    if(this.status && (this.status == StatusSubskrypcji.ZAMOWIONA)) {
      this.maxDateTo = DateHelper.addToDate(this.monitorowanieForm?.get('subskrypcjaOd').value, 1, 0, -1);
      this.minDateTo = DateHelper.addToDate(this.today.toISOString(), 0, 0, 0);
      this.minDate = DateHelper.addToDate(this.today.toISOString(), 0, 0, 0);
      this.disableDataOd = false;
      this.disableDataDo = false;
      this.przedlozORok = false;
    }

    if(this.status && this.status == StatusSubskrypcji.WYGASAJACA) {
      this.przedlozORok = true;
      this.disableDataOd = true;
      this.disableDataDo = true;
      this.minDate = new Date(this.monitorowanieForm?.get('subskrypcjaDo').value);
      this.minDateTo = new Date(this.monitorowanieForm?.get('subskrypcjaDo').value);
      this.maxDateTo = DateHelper.addToDate(this.monitorowanieForm?.get('subskrypcjaDo').value, 1, 0, -1);
      this.monitorowanieForm?.get('subskrypcjaDo').setValue(this.maxDateTo);
    }

    if((this.status && this.status == StatusSubskrypcji.ODWOLANA || this.status == StatusSubskrypcji.WYGASLA) || !this.status) {
      this.minDate = DateHelper.addToDate(this.today.toISOString(), 0, 0, 0);
      this.minDateTo = DateHelper.addToDate(this.today.toISOString(), 0, 0, 0);
      this.maxDate = null;
      this.maxDateTo = DateHelper.addToDate(this.today.toISOString(), 1, 0, -1);
      this.monitorowanieForm?.get('subskrypcjaOd').setValue(this.minDate);
      this.monitorowanieForm?.get('subskrypcjaDo').setValue(DateHelper.addToDate(this.today.toISOString(), 1, 0, -1));
      this.disableDataOd = false;
      this.przedlozORok = false;
    }

    this.monitorowanieForm?.get('przedlozORok').valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((checked: boolean) => {
        if(!checked) {
          this.disableDataDo = false;
        } else {
          this.disableDataDo = true;
          this.monitorowanieForm?.get('subskrypcjaDo').setValue(this.maxDateTo);
        }
      });

    this.monitorowanieForm?.get('subskrypcjaOd').valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value: string) => {
        this.minDateTo = new Date(value);
        this.maxDateTo = DateHelper.addToDate(value, 1, 0, -1);
        const maxDateTo = new Date(this.monitorowanieForm?.get('subskrypcjaDo').value);

        if(this.minDateTo.getTime() > maxDateTo.getTime() || DateHelper.dateDiffInDays(this.minDateTo, maxDateTo) >= 365) {
          this.monitorowanieForm?.get('subskrypcjaDo').setValue(null);
        }
      });

    this.cdr.detectChanges();
  }
}
